// extracted by mini-css-extract-plugin
module.exports = {"container":"ScheduleLegend_container__pB6Is","freeform":"ScheduleLegend_freeform__PzVUF","specialty":"ScheduleLegend_specialty__Indsq","cp":"ScheduleLegend_cp__DzAUB"};